module.exports = __webpack_public_path__ + "img/bpdoctor_y003@2x.ce10096a.png";